import { useLocalStorage } from '@/lib/helpers/storage'

/*
 * Store the last viewed route in LocalStorage.
 * Used to return SSO'd users back to where they came from.
 */
export default function({ route }) {
  if (process.static) return

  // Array of Route Paths we don't want to store
  const skip = [/^\/sso\/login$/, /^\/dashboard\/[a-zA-Z0-9_].*\/upgrade$/]

  if (!skip.some(path => route.path.match(path))) {
    useLocalStorage().setItem('lastViewedRoute', route.path)
  }
}
